import { Injectable, inject } from "@angular/core";
import {
  RemoteConfig,
  fetchAndActivate,
  getString
} from "@angular/fire/remote-config";

@Injectable({
  providedIn: "root"
})
export class FirebaseRemoteConfigService {
  private remoteConfig: RemoteConfig = inject(RemoteConfig);

  constructor() {
    this.initializeRemoteConfig();
  }

  private async initializeRemoteConfig() {
    try {
      await fetchAndActivate(this.remoteConfig);
    } catch (error) {
      console.error("Error fetching remote config:", error);
    }
  }

  public async getRemoteConfigValue(configKey: string): Promise<string> {
    return getString(this.remoteConfig, configKey);
  }
}
